// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { Fragment, useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Siriwave from 'react-siriwave';

import { CardBlur, Spotlight } from 'components';
import FadeInSection from 'components/FadeInSection';

import { Container, Wrapper } from './styles';
import { ReactComponent as Left } from 'assets/icons/left.svg';
import PurpleMobile from 'assets/icons/pink-mobile.png';
import { ReactComponent as RightArrow } from 'assets/icons/right-arrow.svg';
import { ReactComponent as Right } from 'assets/icons/right.svg';
import Pic1 from 'assets/images/testimonials/pic-1.png';
import Pic2 from 'assets/images/testimonials/pic-2.png';
import Pic3 from 'assets/images/testimonials/pic-3.png';
import useScreenSize from 'hooks/useScreenSize';

const testimonialsPrefix = 'pages.home.views.testimonials' as const;

export const Testimonials = () => {
  const screenSize = useScreenSize();
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.home.views.testimonials',
  });

  const isMobileQuery = useMemo(() => {
    if (screenSize === 'sm' || screenSize === 'xs') {
      return true;
    }

    return false;
  }, [screenSize]);

  return (
    <Container id={'testimonials'}>
      {!isMobileQuery ? (
        <Fragment>
          <Left className={'left'} />
          <Right className={'right'} />
        </Fragment>
      ) : undefined}
      <Wrapper>
        {!isMobileQuery ? (
          <div className={'content'}>
            <Spotlight text={'Testimonials & Case Studies'} />
          </div>
        ) : (
          <FadeInSection>
            <div className={'mobile-title'}>
              <h1>
                <Trans
                  i18nKey={`${testimonialsPrefix}.title`}
                  components={{
                    b: <strong />,
                  }}
                />
              </h1>
              <Siriwave
                theme={'ios9'}
                cover={false}
                height={80}
                amplitude={2.24}
              />
            </div>
          </FadeInSection>
        )}

        <div className={'card-wrapper'}>
          {/* {isMobileQuery ? <img src={PurpleOne} alt='' /> : undefined}
          {isMobileQuery ? <img src={PurpleTwo} alt='' /> : undefined} */}
          {isMobileQuery ? <img src={PurpleMobile} alt='' /> : undefined}
          <CardBlur borderRadius={isMobileQuery ? 10 : 30}>
            <FadeInSection>
              <header>
                <img src={Pic1} alt={'Alex montrey'} />
                <h3>{t('cards.one.id')}</h3>
              </header>
              <div className={'card-inside'}>
                <div>
                  <p>{t('cards.one.description1')}</p>
                  <p>{t('cards.one.description2')}</p>
                </div>
                <footer>
                  <div>
                    <h3>{t('cards.one.id')}</h3>
                    <span>{t('cards.one.role')}</span>
                  </div>
                  <a href={t('cards.one.link')} target='_blank'>
                    <RightArrow />
                  </a>
                </footer>
              </div>
            </FadeInSection>
          </CardBlur>
          <CardBlur borderRadius={isMobileQuery ? 10 : 30}>
            <FadeInSection>
              <header>
                <img src={Pic2} alt={'Marcus'} />
                <h3>{t('cards.two.id')}</h3>
              </header>
              <div className={'card-inside'}>
                <div>
                  <p>{t('cards.two.description1')}</p>
                  <p>{t('cards.two.description2')}</p>
                </div>
                <footer>
                  <div>
                    <h3>{t('cards.two.id')}</h3>
                    <span>{t('cards.two.role')}</span>
                  </div>
                  <a href={t('cards.two.link')} target='_blank'>
                    <RightArrow />
                  </a>
                </footer>
              </div>
            </FadeInSection>
          </CardBlur>
          <CardBlur borderRadius={isMobileQuery ? 10 : 30}>
            <FadeInSection>
              <header>
                <img src={Pic3} alt={'Vladut'} />
                <h3>{t('cards.three.id')}</h3>
              </header>
              <div className={'card-inside'}>
                <div>
                  <p>{t('cards.three.description1')}</p>
                  <p>{t('cards.three.description2')}</p>
                </div>
                <footer>
                  <div>
                    <h3>{t('cards.three.id')}</h3>
                    <span>{t('cards.three.role')}</span>
                  </div>
                  <a href={t('cards.three.link')} target='_blank'>
                    <RightArrow />
                  </a>
                </footer>
              </div>
            </FadeInSection>
          </CardBlur>
        </div>
      </Wrapper>
    </Container>
  );
};
